const TOOLTIPS = {
  egift: "Digital Delivery | Valid Online Only",
  voucher: "Digital Delivery | Valid In Store Only",
  physical: "Delivered By Mail in 3-14 Days | Valid In Store Only",
  egiftAndVoucher: "Digital Delivery | Valid Online & In Store"
};

export const selectTooltip = (deliveryType) => {
  const isSingle =
    Object.keys(deliveryType).filter((type) => deliveryType[type]).length === 1;

  if (isSingle && deliveryType.egift) {
    return TOOLTIPS.egift;
  }

  if (isSingle && deliveryType.voucher) {
    return TOOLTIPS.voucher;
  }

  if (isSingle && deliveryType.physical) {
    return TOOLTIPS.physical;
  }

  if (!isSingle && deliveryType.egift && deliveryType.voucher) {
    return TOOLTIPS.egiftAndVoucher;
  }
};
